import React from "react";
import { Grid as AntdGrid, Row as AntdRow, Col as AntdCol } from "antd";
import type {
  RowProps as AntdRowProps,
  ColProps as AntdColProps,
  Breakpoint as AntdBreakpoint,
} from "antd";

export type RowProps = AntdRowProps;
export type ColProps = AntdColProps;
export type Breakpoint = AntdBreakpoint;

/**
 * Row component - grid row layout
 */
export const Row: React.FC<RowProps> = (props) => {
  return <AntdRow {...props} />;
};

/**
 * Col component - grid column layout
 */
export const Col: React.FC<ColProps> = (props) => {
  return <AntdCol {...props} />;
};

/**
 * Grid utilities - exposes responsive breakpoint hook
 */
const Grid = {
  Row,
  Col,
  useBreakpoint: AntdGrid.useBreakpoint,
};

export const useBreakpoint = AntdGrid.useBreakpoint;

export default Grid;
